/* ============================================================
   Career page — Benifits Of Working 
   ------------------------------------------------------------
   Imports only the JS components this page's markup uses, mirrors
   assets/css/pages/home.css.
   ============================================================ */
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initSlimSelects } from "../component/custom-select.js";
import { initCustomModal } from "../component/custom-modal.js";
import { initCareerForm } from "../component/career-form-submossion.js";
import { initCookieBar,initDmcabadge,initGooglePreferredSource } from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initDmcabadge();
initCookieBar();
initOfficeHoverReveal();
initGooglePreferredSource();
initSlimSelects();
initCustomModal();
initCareerForm();
initMobileMenu();

document.addEventListener("DOMContentLoaded", () => {
    initGlowWrapper();
});
